
import React, { useEffect, useRef, useState } from "react";
import logo from '../assets/images/logo.svg';
import TopNav from "./TopNav";
import Footer from "./Footer";

function ProfileSec(props) {
    return(
        <div className="pagewrapper" id="profile-page">
            <div className="blur">
            <div className="container">
                <TopNav />

                <div className="clear" />
                <div className="content">
                    <a href title className="link-button ease box-sizing radius50">ایجاد دوره ختم جدید</a>
                    <a href title className="link-button ease box-sizing radius50">ورود به دوره ختم ایجاد شده</a>
                    <a href title className="link-button blue ease box-sizing radius50">بازگشت</a>
                </div>

            </div>
            <div className="clear" />
            <Footer />
            </div>
        </div>
    )
}
export default  ProfileSec